

const RECENT_VIEWS_KEY = "recentlyViewedContractors";
// const MAX_RECENT_VIEWS = 50; // Maximum number of recent views to store

export const getRecentViews = () => {
  if (typeof window === "undefined") return [];

  try {
    const stored = localStorage.getItem(RECENT_VIEWS_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error("Error reading recent views from localStorage:", error);
    return [];
  }
};

export const addToRecentViews = (contractor) => {
  if (typeof window === "undefined") return;

  try {
    const recentViews = getRecentViews();

    // Remove existing entry with same id (if any) to avoid duplicates
    const filteredViews = recentViews.filter(
      (view) => view.id !== contractor.id
    );

    // Add new entry at the beginning
    const updatedViews = [contractor, ...filteredViews];

    // Limit to MAX_RECENT_VIEWS
    // const limitedViews = updatedViews.slice(0, MAX_RECENT_VIEWS);

    localStorage.setItem(RECENT_VIEWS_KEY, JSON.stringify(updatedViews));

    // Dispatch custom event for same-tab updates
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event("recentViewsUpdated"));
    }
  } catch (error) {
    console.error("Error saving recent view to localStorage:", error);
  }
};

